import type { Location } from 'history'

export function isNextSkipNavigationState(input: any): input is { skipNavigationPrompt: boolean } {
  return typeof input === 'object' && input !== null && 'skipNavigationPrompt' in input
}

export function shouldSkipConfirmation(location: Location): boolean {
  return (
    typeof location.state === 'object' &&
    location.state !== null &&
    'skipNavigationPrompt' in location.state &&
    typeof location.state.skipNavigationPrompt === 'boolean' &&
    location.state.skipNavigationPrompt
  )
}

export function shouldShowConfirmation(location: Location): boolean {
  return (
    typeof location.state === 'object' &&
    location.state !== null &&
    (('showNavigationPrompt' in location.state &&
      typeof location.state.showNavigationPrompt === 'boolean' &&
      location.state.showNavigationPrompt) ||
      ('pendingShopChange' in location.state &&
        typeof location.state.pendingShopChange === 'boolean' &&
        location.state.pendingShopChange) ||
      ('pendingLogout' in location.state && typeof location.state.pendingLogout === 'boolean' && location.state.pendingLogout))
  )
}
